import styled from 'styled-components'

const StyledNotLoggedIn = styled.div`
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  a {
    margin-top: 10px;
    text-decoration: underline;
    font-weight: 600;
  }
  h1 {
    font-family: ${({ theme }) => theme.fonts.playfairDisplay};
    font-size: 50px;
    margin-bottom: 40px;
  }
  .message {
    margin: 10px 0;
  }
  .italics {
    font-style: italic;
  }
`

export default StyledNotLoggedIn
